/**
 * "Bentomax-Techniker" ist keine Spalte am Benutzer, sondern ein abgeleitetes
 * Prädikat: die Firma muss "bentomax" enthalten und der Benutzer darf kein
 * Subunternehmer sein. Pendant im Backend: User#is_bentomax_technician
 * (app/models/user.rb) bzw. der Scope User.bentomax_user.
 */

const BENTOMAX_COMPANY_MARKER = 'bentomax';
const SUBCONTRACTOR_ROLE = 'SUBCONTRACTOR';
const TECHNICIAN_ROLE = 'TECHNICIAN';

export interface BentomaxCompanyCheck {
  /** users.address_company */
  addressCompany?: string | null;
  /** users.company_address_company — auf Masken ohne dieses Feld einfach weglassen */
  companyAddressCompany?: string | null;
  /** Rollennamen des Benutzers, z.B. ['USER', 'TECHNICIAN'] */
  roleNames: string[];
}

/**
 * Firmenname enthält "bentomax" und der Benutzer ist kein Subunternehmer.
 * Identisch zur Backend-Logik — bewusst ohne Rollenprüfung, weil die Aufrufer
 * im Planungsassistenten ohnehin schon nur Techniker verarbeiten.
 */
export function matchesBentomaxCompany(check: BentomaxCompanyCheck): boolean {
  const companyMatches = [check.addressCompany, check.companyAddressCompany].some(company =>
    !!company && company.toLowerCase().includes(BENTOMAX_COMPANY_MARKER),
  );

  return companyMatches && !check.roleNames.includes(SUBCONTRACTOR_ROLE);
}

/**
 * Wie matchesBentomaxCompany, verlangt zusätzlich die Technikerrolle. Dafür
 * gedacht, auf den Benutzer-Masken zu erkennen, ob eine Versandfiliale gesetzt
 * sein sollte — dort kann jede Art von Benutzer angelegt werden, nicht nur Techniker.
 */
export function isBentomaxTechnician(check: BentomaxCompanyCheck): boolean {
  return check.roleNames.includes(TECHNICIAN_ROLE) && matchesBentomaxCompany(check);
}
